import { loadFromAPIs } from './fetch';
import { apiKey, sponsorApiUrl } from './WindowContext';

import type { Sponsor } from '@shared-types/sponsor.types';

export const getSponsorDataFromService = (competitionId: string, useMainSponsors = false, signal?: AbortSignal) => {
  const sponsorPhase = window.sponsorPhase || 'TOURNAMENT';
  const params = {
    competitionAndPhase: `${competitionId}:${sponsorPhase}`,
    platform: useMainSponsors ? null : 'DEFAULT',
  };

  const path = useMainSponsors ? 'v2/sponsors/main' : 'v2/sponsors';

  return loadFromAPIs<Sponsor[]>(path, params, { apiKey, apiUrl: sponsorApiUrl, signal });
};
